import type { Decoration } from './../../ricos-schema/legacy/wix/rich_content/v1/index.js';
import { Decoration_Type } from './../../ricos-schema/legacy/wix/rich_content/v1/index.js';
import type { CustomTextualStyle } from './../../ricos-types/index.js';

import type { TextDecoration } from '../models/decoration.js';

export class EmptyDecoration implements TextDecoration {
  type = Decoration_Type.UNRECOGNIZED;

  getDecoration(): Decoration {
    return {} as Decoration;
  }

  fromCustomStyle(_customStyle: CustomTextualStyle): TextDecoration {
    return new EmptyDecoration();
  }

  toCustomStyle(): CustomTextualStyle {
    return {};
  }

  overrideWith(decoration: TextDecoration): TextDecoration {
    return decoration;
  }
}
